import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { TrackingCode } from "../../../tracking-report/tracking-report.component";
import { TrackingReportService } from "../../../_services/tracking-report.service";

@Component({
  selector: "app-tracking-print",
  templateUrl: "tracking-print.component.html",
  styleUrls: ["tracking-print.component.css"],
})
export class TrackingPrintComponent implements OnInit, OnDestroy {
  @ViewChild("tackInput") public tackInput: any;
  @ViewChild("printButton") public printButton: any;
  public trackingCode: string | undefined;
  public userFullName: string;
  public bottom = "bottom";
  public top = "top";
  public left = "left";
  public center = "center";
  public mTop = 20;
  public mBottom = 1;
  public sizetwo = 70;
  public fsize = 12;
  public sizeBarcode = 1.5;
  public sendTackInput: TrackingCode;
  public sendTackMessage = null;
  public disabledBtn = true;
  public inpValue = "";

  constructor(private trackingReport: TrackingReportService) {}

  ngOnInit() {}

  handleValue(e) {
    this.inpValue = e.target.value;
  }

  onEnter() {
    this.sendTackMessage = null;
    if (this.tackInput.nativeElement.value !== "") {
      this.sendTackInput = {
        tracking_code: "",
      };

      this.sendTackInput.tracking_code =
        this.tackInput.nativeElement.value || this.inpValue;
      this.trackingCode = this.tackInput.nativeElement.value || this.inpValue;
      this.trackingReport
        .chekInputTrack(this.sendTackInput)
        .subscribe((data) => {
          if (data.status === 200) {
            if (data.order) {
              this.userFullName = data.order.client_fullname
                ? data.order.client_fullname
                : data.order.orderer_info;
              this.sendTackMessage = data.message;
              this.disabledBtn = false;
              setTimeout(() => {
                this.printButton.nativeElement.click();
              }, 0);
            }
            if (data.message) {
              this.disabledBtn = true;
              this.sendTackMessage = data.message;
            }
          }
        });
    }
    setTimeout(() => {
      this.sendTackMessage = null;
    }, 2000);
  }

  ngOnDestroy() {}
}
